import React, { memo } from 'react';
import CarouselCell from '../../SectionListCrud/editCells/CarouselCell';

const CarouselReadCell = (props) => {
    return <CarouselCell {...props} isReadOnly />;
};

export default memo(CarouselReadCell);
